import React  from 'react';
import { Button, Box, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

function FancyFileUploadButton({file, handleFileUpload}) {

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Button
        variant="contained"
        component="label"
        startIcon={<UploadFileIcon />}
        sx={{
          backgroundColor: '#1976d2', // Customize your color
          color: '#fff',
          padding: '10px 20px',
          fontSize: '16px',
          borderRadius: '8px',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: '#1565c0', // Hover color
          },
        }}
      >
        Upload File
        <input type="file" accept=".json"  hidden onChange={handleFileUpload} />
      </Button>
      <Typography variant="caption" sx={{ marginTop: '8px', color: '#757575' }}>
        {file? file.name: "Choose a file to upload"}
      </Typography>
    </Box>
  );
}

export default FancyFileUploadButton;